<template>
  <div class="tr columns">
    <span class="delete-cell"><img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteServiceRequest(request.id)"/></span>
    <span class="name column">{{ request.name }}</span>
    <span class="phone column">
      <strong>Телефон: </strong><br>{{ request.phone }} <br> 
      <strong>email: </strong><br>{{ request.email }} <br>
      <div v-if="request.city">
        <strong>Город: </strong><br>{{ request.city }} <br>
      </div>
    </span>
    <span class="file column">{{ request.TINNumber }}</span>
    <span class="column">
      <span class="link"><a :href='request.file' target="_blank">{{ formatedFileName }}</a></span>
    </span>
    <span class="column">
      <b-switch v-model="request.isProcessed" @change="updateServiceRequest(request)">Обработан</b-switch>
    </span>
    <span>{{ request.created_at | formatDate }}</span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ServiceRequestItem',
  data () {
    return {
      updateTimer: null,
      showUrl: false
    }
  },
  computed: {
    formatedFileName () {
      return this.request.file ? this.request.file.split('/').pop() : ''
    }
  },
  props: {
    request: {
      required: true
    }
  },
  methods: {
    ...mapActions(['updateServiceRequest', 'deleteServiceRequest'])
  },
  filters: {
    formatDate (date) {
      if (date) {
        const d = new Date(date)
        return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`
      }
    }
  }
}
</script>
<style scoped>
span {
  padding: 15px;
  display: inline-block;
  min-width: 15%;
}
.tr {
  background: #eee;
  margin: 10px 5px;
}
.name {
  font-weight: bold;
}
.link {
  padding: 0;
}
.delete-icon {
  position: initial;
  vertical-align: middle;
}
a:visited {
  color: #1464f6;
}
.delete-cell {
  min-width: 55px;
}
</style>



// WEBPACK FOOTER //
// ServiceRequestItem.vue?35119525